import { useState, useEffect } from "react";
import { WifiOff, Wifi } from "lucide-react";

export default function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  const [showReconnect, setShowReconnect] = useState(false);

  useEffect(() => {
    const goOnline = () => {
      setOnline(true);
      setShowReconnect(true);
      setTimeout(() => setShowReconnect(false), 3000);
    };
    const goOffline = () => { setOnline(false); setShowReconnect(false); };
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (online && !showReconnect) return null;

  return (
    <div
      data-testid="offline-banner"
      className={`fixed bottom-0 left-0 right-0 z-50 px-4 py-2.5 text-center text-sm font-bold flex items-center justify-center gap-2 transition-all ${
        online ? "bg-emerald-500 text-white" : "bg-red-500 text-white"
      }`}
      style={{ fontFamily: 'Outfit, sans-serif' }}
    >
      {online ? (
        <><Wifi className="w-4 h-4" /> Back online — your drafts will sync</>
      ) : (
        <><WifiOff className="w-4 h-4" /> You're offline — forms are saved locally</>
      )}
    </div>
  );
}
